<template>
  <div class="main">
    <div class="wrapper">
      <div class="dialog">
        <div class="title">
          <p class="title_p">Login</p>
        </div>
        <div class="content">
          <ul class="common-form">
            <li class="username border-1p">
              <div class="input">
                <input style="cursor: pointer" class="inputPhone" type="text" v-model="phone" placeholder="phone">
              </div>
            </li>
            <li class="username border-1p" v-show="loginType == 1">
              <div class="input">
                <input style="cursor: pointer" class="inputPhone" type="password" v-model="password" placeholder="password">
              </div>
            </li>
            <li class="username border-1p">
              <div style="cursor: pointer" class="login" v-show="loginType==1">
                login
              </div>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {message} from 'element-ui';
  import messageContent from '../js/message';
  import qs from 'qs';
	export default {
		name: "loginPage",
    data(){
			return {
				show: true,
				count: 5,
				timer: null,
				phone: '',
				password: '',
				loginType: 1,
				code: '',
				cid: '',
				title: "验证码",
      }
    },
    methods: {
			changeLogin(){
				if (this.loginType == 2) {
					this.loginType = 1;
					this.title = "密码";
				} else {
					this.loginType = 2;
					this.title = "验证码";
				}
      },

			loginInit() {
				let obj = {
					code: this.code,
					phone: this.phone,
					loginType: this.loginType,
					password: this.password,
					cid: this.cid
				};
				this.$store.dispatch('login', qs.stringify(obj)).then((res) => {
					if (res.data.code == 200) {
						sessionStorage.removeItem('myEndTime');
						sessionStorage.removeItem('loginPhone');
						sessionStorage.removeItem('loginCode');
						sessionStorage.removeItem('loginPassword');
						sessionStorage.removeItem('htmlPage.url');
						sessionStorage.removeItem('htmlPage.title');
						localStorage.setItem('token', res.data.data.token);

						this.$store.dispatch('findUserInfo').then((res) => {
							localStorage.setItem('currentUserId', res.data.data.id);
							localStorage.setItem('currentPhone', res.data.data.phone);
							localStorage.setItem('currentUniqueId', res.data.data.uniqueId);
							localStorage.setItem('userTypeId', res.data.data.userTypeId);
							localStorage.setItem('avatarUrl', res.data.data.avatarUrl);
							localStorage.setItem('name', res.data.data.name);
							this.$router.back();
						})
					} else {
						this.$message.error(res.data.message)
					}
				})
			},
      //发送验证码
			sendMessage() {
				if (this.phone.trim().length == 0) {
					this.$message.error(messageContent.phoneEmpty);
					return;
				}
				const regPhone = /^1[3456789]\d{9}$/;
				if (regPhone.test(this.phone) == false) {
					this.$message.error(messageContent.phoneError)
				} else {
					let endMsRes = (new Date()).getTime() + 60000;
					sessionStorage.setItem('myEndTime', JSON.stringify(endMsRes));
					this.codeCountDown(endMsRes);
					let obj = {
						phone: this.phone,
						messageType: 1
					};
					this.$store.dispatch('sendMessageByPhoneAndType', obj).then((res) => {
						if (res.data.code == 200) {
							this.$message.success(messageContent.verificationCodeSent)
						}else {
							this.$message.error(res.data.message)
						}
					})
				}
			},
      //倒计时
			codeCountDown(endMsRes) {
				this.show = false;
				this.count = Math.ceil((endMsRes - (new Date()).getTime()) / 1000);
				this.timer = setTimeout(() => {
					this.count--;
					if (this.count < 1) {
						this.show = true;
						this.count = 60;
						clearTimeout(this.timer)
					} else {
						this.codeCountDown(endMsRes)
					}
				}, 1000)
			},
    }
	}
</script>

<style lang="scss" scoped>
  .main{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #f2f2f2;
  }
  .wrapper {
    min-height: 800px;
    min-width: 630px;
    .dialog{
      width: 450px;
      height: 500px;
      border: 1px solid #dadada;
      border-radius: 10px;
      margin: 80px auto;
      background: #fff;
      .title{
        display: flex;
        justify-content: center;
        flex-direction: column;
        .title_p{
          text-align: center;
          font-weight: bolder;
          font-size: 40px;
          height: 100px;
          line-height: 100px;
          color: #000;
        }
        h4 {
          color: #666;
          font-size: 20px;
          padding-bottom: 30px;
          text-align: center;
        }
      }
      .content{
        li{
          width: 80%;
          clear: both;
          position: relative;
          margin: 0 auto 30px;
          .input{
            height: 50px;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-align: center;
            align-items: center;
            .inputPhone{
              font-size: 16px;
              width: 100%;
              height: 100%;
              padding: 10px 15px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 6px;
              outline: none;
            }
            .inputCode{
              font-size: 16px;
              width: 50%;
              height: 100%;
              padding: 10px 15px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 6px;
              outline: none;
            }
            span{
              font-size: 16px;
              width: 40%;
              margin-left: 10%;
              height: 100%;
              line-height: 50px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 6px;
              outline: none;
              text-align: center;
            }
          }
          .login{
            height: 50px;
            background: #B0BECB;
            line-height: 50px;
            border: 1px solid #ccc;
            border-radius: 6px;
            text-align: center;
          }
        }
        .changeLogin{
          width: 80%;
          clear: both;
          position: relative;
          margin: 0 auto 15px;
          text-decoration: underline;
          color: #ccc;
          text-align: right;
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/login/loginUserPage.vue